import { Field } from "./components/Field";
import { useEffect, useState } from "react";
import { InputField } from "./components/InputField";
import { ContainerField } from "./components/Container";
import { RadioGroupField } from "./components/RadioGroupField";
import { SelectField } from "./components/SelectField";
import { AutocompleteField } from "./components/AutocompleteField";

const FormRender = ({ schema }: { schema: any }) => {

    const [fields, setFields] = useState<Field[]>([]);

    useEffect(() => {
        const comps = schema.map((comp: any) => {
            if (comp.formTag === 'InputField') {
                return InputField.fromJSON(comp);
            }
            if (comp.formTag === 'ContainerField') {
                return ContainerField.fromJSON(comp);
            }
            if (comp.formTag === 'RadioGroupField') {
                return RadioGroupField.fromJSON(comp);
            }
            if (comp.formTag === 'SelectField') {
                return SelectField.fromJSON(comp);
            }
            if (comp.formTag === 'AutocompleteField') {
                return AutocompleteField.fromJSON(comp);
            }
        });
        setFields(comps);
    }, [schema]);


    return (
        <>
            {fields.map((field: Field, index) => field.render())}
        </>
    );
}

export default FormRender;